// 配置路由
import Vue from "vue";
import VueRouter from 'vue-router';
// 使用插件
Vue.use(VueRouter);

// 引入组件
import Index from "@/views/Index.vue";
import Login from "@/views/login/Login.vue";
import Search from "@/views/Search.vue";
import GongSi from "@/views/GongSiList.vue";
import GongSiDetails from "@/views/GongSiDetails.vue";
import Chat from "@/views/Chat.vue";
import Personal from "@/views/Personal.vue";
import JobDetails from "@/views/JobDetails.vue";
import Resume from "@/views/Resume.vue";
import PrivacySet from "@/views/PrivacySet.vue";
import Account from "@/views/Account.vue";
import License from "@/views/License.vue";
import Permit from "@/views/Permit.vue";

// 校园招聘模块前台组件
import RecruitmentPortal from "@/views/recruitment/Portal.vue";
import RecruitmentApply from "@/views/recruitment/Apply.vue";
import RecruitmentDashboard from "@/views/recruitment/Dashboard.vue";


const hostname = window.location.hostname;
const domainParts = hostname.split('.');
const isSubdomain = 
    domainParts.length > 2 && 
    domainParts[0] !== 'www' && 
    domainParts[0] !== 'm' && 
    !hostname.includes('localhost') && 
    !/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname);

const routes = [
    // 首页
    {
        path: "/index",
        component: isSubdomain ? RecruitmentPortal : Index,
        meta: { show: true, title: isSubdomain ? '校园招聘-企业官网' : '职远速聘-找高薪工作上职远速聘！招聘求职找工作！', keepAlive: true }
    },
    // 校园招聘官网主页
    {
        path: "/recruitment/portal",
        component: RecruitmentPortal,
        meta: { show: false, title: '校园招聘-企业官网' }
    },
    // 校园招聘在线报名表单
    {
        path: "/recruitment/apply/:eventId",
        component: RecruitmentApply,
        meta: { show: false, title: '校园招聘-在线报名' }
    },
    // 校园招聘考生个人中心
    {
        path: "/recruitment/dashboard",
        component: RecruitmentDashboard,
        meta: { show: false, title: '校园招聘-考生个人中心' }
    },
    // 其他路径全返回首页
    {
        path: '*',
        redirect: '/index'
    },
    // // 验证token
    // {
    //     path: '/verifyToken',  //链接路径
    //     component: VerifyToken,    //对应的组件模板
    //     meta: { show: true, title: '' }
    // },
    // 注册页面
    {
        path: '/login',  //链接路径
        component: Login,    //对应的组件模板
        meta: { show: true, title: '注册-找高薪工作上职远速聘！招聘求职找工作！' }
    },
    // // 个人中心
    // {
    //     path: '/me',  //链接路径
    //     component: Me,    //对应的组件模板
    //     meta: { show: true, title: '核芯营养管理平台', keepAlive: true }
    // },
    {
        path: '/search',  //链接路径
        component: Search,    //对应的组件模板
        meta: { show: true, title: '搜索-找高薪工作上职远速聘！招聘求职找工作！' }
    },
    {
        path: '/gongsi',  //链接路径
        component: GongSi,    //对应的组件模板
        meta: { show: true, title: '公司-找高薪工作上职远速聘！招聘求职找工作！' }
    },
    {
        path: '/gongsi/:id',  //链接路径
        component: GongSiDetails,    //对应的组件模板
        meta: { show: true, title: '公司详情-找高薪工作上职远速聘！招聘求职找工作！' }
    },
    {
        path: '/chat',  //链接路径
        component: Chat,    //对应的组件模板
        meta: { show: true, title: '消息-找高薪工作上职远速聘！招聘求职找工作！' }
    },
    {
        path: '/personal',  //链接路径
        component: Personal,    //对应的组件模板
        meta: { show: true, title: '个人中心-找高薪工作上职远速聘！招聘求职找工作！' }
    },
    {
        path: '/jobdetail/:id',  //链接路径
        component: JobDetails,    //对应的组件模板
        meta: { show: true, title: '职位详情-找高薪工作上职远速聘！招聘求职找工作！' }
    },
    {
        path: '/resume',  //链接路径
        component: Resume,    //对应的组件模板
        meta: { show: true, title: '简历-找高薪工作上职远速聘！招聘求职找工作！' }
    },
    {
        path: '/privacyset',  //链接路径
        component: PrivacySet,    //对应的组件模板
        meta: { show: true, title: '隐私设置-找高薪工作上职远速聘！招聘求职找工作！' }
    },
    {
        path: '/account',  //链接路径
        component: Account,    //对应的组件模板
        meta: { show: true, title: '账户中心-找高薪工作上职远速聘！招聘求职找工作！' }
    },
    {
        path: '/license',  //链接路径
        component: License,    //对应的组件模板
        meta: { show: true, title: '营业执照-找高薪工作上职远速聘！招聘求职找工作！' }
    },
    {
        path: '/permit',  //链接路径
        component: Permit,    //对应的组件模板
        meta: { show: true, title: '人力资源许可证-找高薪工作上职远速聘！招聘求职找工作！' }
    },

]

// 创建路由实例
const router = new VueRouter({
    // 默认使用的是hash模式，url中带#号。history不带#号
    // mode: 'history',
    mode: 'hash',
    routes,
    // scrollBehavior() {
    //     return { x: 0, y: 0 }
    // }
})

export default router
